// @flow
import * as React from 'react';
import {useAccount} from 'docs/data';
import PropertyList, {PropertyListItem} from 'sail/PropertyList';
import Card from 'sail/Card';
import {Intro} from 'sail/Text';
import Group from 'sail/Group';
import Box from 'sail/Box';
import Button from 'sail/Button';
import TruncatedText from 'sail/TruncatedText';

const {useState} = React;

type ApiWorksheetProps = {|
  children: Array<Object>,
|};

export const ApiWorksheet = ({children}: ApiWorksheetProps) => {
  const {account} = useAccount();
  const apiKey = account.keys.secret;
  const [currentPromptIndex, setCurrentPromptIndex] = useState(0);
  const [stickyData, setStickyData] = useState([]);
  const [hasStarted, setHasStarted] = useState(false);

  const promptText = children[0].props.children.props.children.filter(
    (child) => child.type?.name !== 'Hint' && child.type?.name !== 'Success',
  );

  // Only append to the stickyData if the prompt's 'sticky' prop isn't empty
  const nextPrompt = (stickyResult) => {
    if (currentPromptIndex + 1 < children.length) {
      if (stickyResult.sticky !== '') {
        setStickyData([...stickyData, stickyResult]);
      }
      setCurrentPromptIndex(currentPromptIndex + 1);
    }
  };

  // Keep a list of sticky data and add an item after each successful prompt
  const stickyList = stickyData.map(function({sticky, answer}) {
    return <PropertyListItem key={answer} label={sticky} definition={answer} />;
  });

  // Attach the nextPrompt function to all children of type Prompt
  const childrenWithProps = React.Children.map(children, (child, index) => {
    if (React.isValidElement(child) && child.type?.name === 'Prompt') {
      return React.cloneElement(child, {nextPrompt, apiKey, account});
    }
    return child;
  });

  return (
    <>
      {stickyData.length !== 0 ? (
        <PropertyList layout="stacked" divider>
          {stickyList}
        </PropertyList>
      ) : null}
      {hasStarted ? (
        childrenWithProps[currentPromptIndex]
      ) : (
        <Card radius="all" shadow="medium" margin={{top: 8, bottom: 8}}>
          <Box background="blue50" padding={20}>
            <Group spacing={8} direction="vertical">
              <Box style={{maxWidth: '42em'}}>
                <Intro>
                  <TruncatedText>{promptText}</TruncatedText>
                </Intro>
              </Box>
              <Button
                icon="arrowRight"
                iconPosition="right"
                color="primary"
                size="medium"
                label="Get started"
                onClick={() => setHasStarted(true)}
              />
            </Group>
          </Box>
        </Card>
      )}
    </>
  );
};
